// extracted by mini-css-extract-plugin
export default {"inputDropdown":"InputSuspense_inputDropdown__E7gKh","dropDown":"InputSuspense_dropDown__brcis","itens":"InputSuspense_itens__C5li8","input":"InputSuspense_input__adGW1"};